module.exports = __webpack_public_path__ + "img/TiDB.7f5f0a9e.jpg";